export default "__VITE_ASSET__2be32c3e__"